import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Field, Input, Label, Popover, PopoverSurface, PopoverTrigger, Spinner, Subtitle2, Text } from "@fluentui/react-components";
import { Edit12Regular } from "@fluentui/react-icons";

// component functions 
import * as ComponentFunctions from './ConsumptionAmount.functions';

// styles
import './ConsumptionAmount.Styles.css';
import { Separator } from "@fluentui/react";
import { CurrencySelectorComponent } from "../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent";


const ConsumptionAmountComponent = (props: ComponentFunctions.Props) => {

    const [newValue, setNewValue] = useState<number>(props.Consumption?.unitAmount || 0);

    const [selectedCurrency, setSelectedCurrency] = useState<string>(props.Consumption?.currencyCode || 'USD');

    const InternalForm = (
        <div>
            <Subtitle2>Monto unitario del concepto</Subtitle2>
            <Field label={"Monto"}>
                <Input
                    step={0.01}
                    type="number"
                    value={newValue?.toString()}
                    onChange={(e) => setNewValue(parseFloat(e.target.value))}
                />
            </Field>
            <Field label={"Moneda"}>
                <CurrencySelectorComponent
                    errorMessage={undefined}
                    defaultSelected={selectedCurrency}
                    label={undefined}
                    onCurrencyChange={(currency: string) => setSelectedCurrency(currency)}
                />
            </Field>
            <Separator />
            <Button
                disabled={props.isChangingAmount}
                appearance="primary"
                onClick={() => props.ChangeAmount(props.ProtocolId, props.ProtocolConsumptionId, newValue, selectedCurrency)}
            >
                {props.isChangingAmount && <Spinner size="extra-tiny" />}{' '}Guardar
            </Button>
        </div >
    );

    return (
        <div className="consumtionUnitAmountMiniForm">
            {props.Consumption && <Label>{props.Consumption?.unitAmount?.toLocaleString('es-AR', { style: 'currency', currency: props.Consumption?.currencyCode?.toUpperCase() }) ?? '0.00'}</Label>}
            <Popover withArrow={true}>
                <PopoverTrigger disableButtonEnhancement>
                    <Button
                        appearance="subtle"
                        aria-label="Close"
                        icon={<Edit12Regular />}
                        onClick={() => undefined}
                    />
                </PopoverTrigger>

                <PopoverSurface tabIndex={-1}>
                    {InternalForm}
                </PopoverSurface>
            </Popover>


        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumptionAmountComponent as any);